var _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Desktop_Computer_24",
    width: 30,
    height: 30,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none",
    fill: "#2188ff",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.83 0 0 0.83 12 12)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#2188ff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-12, -8)",
    d: "M 23.5 2 C 23.5 0.8954305003384131 22.604569499661586 0 21.5 0 L 2.5 0 C 1.395430500338413 0 0.5 0.8954305003384131 0.5 2 L 0.5 14 C 0.5 15.104569499661586 1.395430500338413 16 2.5 16 L 21.5 16 C 22.604569499661586 16 23.5 15.104569499661586 23.5 14 Z M 21.5 13.5 C 21.5 13.776142374915397 21.2761423749154 14 21 14 L 3 14 C 2.7238576250846034 14 2.5 13.776142374915397 2.5 13.5 L 2.5 2.5 C 2.5 2.2238576250846034 2.7238576250846034 2 3 2 L 21 2 C 21.2761423749154 2 21.5 2.2238576250846034 21.5 2.5 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 8.75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#2188ff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-12, -20.75)",
    d: "M 22.33 22.75 L 21.08 18.259999999999998 C 20.967184471427295 17.802816718880752 20.550697177085674 17.48628637518112 20.08 17.499999999999996 L 3.89 17.499999999999996 C 3.422233560181515 17.485199412863526 3.0067660394981646 17.79680005337604 2.89 18.249999999999996 L 1.67 22.76 C 1.5941040787876797 23.059084533149953 1.6605308718334477 23.376456988813068 1.85 23.62 C 2.0408221173094976 23.861492048351334 2.3322196545172336 24.001657952324674 2.6399999999999997 24 L 21.36 24 C 21.667780345482765 24.001657952324674 21.9591778826905 23.861492048351334 22.15 23.62 C 22.339469128166552 23.376456988813068 22.40589592121232 23.059084533149953 22.33 22.76 Z M 16.5 21.75 C 16.5 22.0261423749154 16.2761423749154 22.25 16 22.25 L 8 22.25 C 7.723857625084603 22.25 7.5 22.0261423749154 7.5 21.75 C 7.5 21.4738576250846 7.723857625084603 21.25 8 21.25 L 16 21.25 C 16.2761423749154 21.25 16.5 21.4738576250846 16.5 21.75 Z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.8c3c9494b9e18d3d06e2c4daccc11bf8.svg";
export { ForwardRef as ReactComponent };